import React, { useRef, useState, useEffect } from "react";
import PropTypes from "prop-types";
import Heading from "../../elements/heading";
import PrimaryLink from "../../elements/primary-link";
import { useResize } from "../../utils/resize";
import styles from "./style.scss";
import querystring from "querystring";
import { canUseDOM } from "../../utils/dom";

const TwoColumnLinkList = ({ fields, rendering, lang }) => {
  const { links, orderBy, title, titleType } = fields;

  const isBrowser = typeof window !== "undefined",
    linksRef = useRef(null),
    [isMediaQueryTablet, setIsMediaQueryTablet] = useState(
      isBrowser ? window.matchMedia(styles.mediaQueryTablet).matches : false
    ),
    [linksHeight, setLinksHeight] = useState(null),
    [_links, setLinks] = useState(links);

  const getItemsTotalHeight = items => {
    return items
      .map((item, index) => item.offsetHeight)
      .reduce((a, b) => a + b, 0);
  };

  const sortByText = (a, b, sort) => {
    if (!sort) return undefined;
    const diff = a.fields.link.value.text
      .toLowerCase()
      .localeCompare(b.fields.link.value.text.toLowerCase());
    if (sort === "ASC") {
      return diff;
    }
    return -1 * diff;
  };

  useEffect(() => {
    if (isMediaQueryTablet && linksRef.current) {
      let firstColumnHeight,
        itemsArray = Array.from(linksRef.current.querySelectorAll(".item"));
      if (links.length < 5)
        firstColumnHeight = getItemsTotalHeight(itemsArray.slice(0, 4));
      else
        firstColumnHeight = getItemsTotalHeight(
          itemsArray.slice(0, Math.ceil(links.length / 2))
        );
      setLinksHeight(firstColumnHeight + +styles.linksPaddingTop);
    } else setLinksHeight(undefined);
  }, [links.length, isMediaQueryTablet]);

  useEffect(() => {
    const search = canUseDOM() ? window.location.search : null;
    const query = search ? querystring.parse(search.substr(1)) : {};

    // handle redirect
    if (query.redirect) {
      let updatedLinks = [];
      links.forEach(link => {
        let pageRedirect = query.redirect;
        let base = link.fields.link.value.href;
        pageRedirect = pageRedirect.replace(`/${lang}/`, "");

        let newLink = `${base}/${pageRedirect}`;
        link.fields.link.value.href = newLink;
        updatedLinks.push(link);
      });
      setLinks(updatedLinks);
    }
  }, []);

  useResize(() => {
    setIsMediaQueryTablet(
      isBrowser ? window.matchMedia(styles.mediaQueryTablet).matches : false
    );
  }, [isMediaQueryTablet]);

  return (
    <div
      className="two-column-link-list grid"
      datasourceid={rendering.dataSource}
    >
      {title && (
        <div className="heading">
          <Heading
            {...{
              html: title,
              type: titleType,
              typographyClass: "type-h3"
            }}
          />
        </div>
      )}
      {_links && (
        <ul
          ref={linksRef}
          style={{
            maxHeight: linksHeight
          }}
          className="links"
        >
          {links
            .sort((a, b) => sortByText(a, b, orderBy.fields.phrase.value))
            .map((item, index) => {
              return (
                <li key={index} className="item">
                  <PrimaryLink
                    {...{
                      ...item.fields,
                      colorScheme: item.fields.colorScheme || "white",
                      icon: item.fields.iconName || {
                        svg:
                          '<svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 0 24 24" width="24"><path d="M0 0h24v24H0V0z" fill="none"/><path d="M12 4l-1.41 1.41L16.17 11H4v2h12.17l-5.58 5.59L12 20l8-8-8-8z"/></svg>'
                      }
                    }}
                  />
                </li>
              );
            })}
        </ul>
      )}
    </div>
  );
};

export default TwoColumnLinkList;

TwoColumnLinkList.propTypes = {
  rendering: PropTypes.shape({ dataSource: PropTypes.string }),
  fields: PropTypes.shape({
    links: PropTypes.array,
    orderBy: PropTypes.object,
    title: PropTypes.object,
    titleType: PropTypes.object
  })
};
